"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _categoryApi = require("@/api/categoryApi");
var _systemSetting = require("@/api/systemSetting");
var _auth = require("@/utils/auth");
var _permission = require("@/utils/permission");
var _vueCropper = require("vue-cropper");
var _validate = require("@/utils/validate");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default2 = exports.default = {
  name: 'uploadPicture',
  props: {
    pictureType: {
      type: String,
      default: ''
    },
    isMore: {
      type: String,
      default: '1'
    },
    modelName: {
      type: String,
      default: ''
    },
    checkedMore: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    labelName: {
      type: String,
      default: ''
    },
    // 是否展示上传视频
    isShowVideo: {
      type: Boolean,
      default: true
    }
  },
  components: {
    VueCropper: _vueCropper.VueCropper
  },
  data: function data() {
    return {
      //grid宽度
      divWidth: null,
      checkDialogData: {},
      //列表类型 1 宫格 0 列表
      listType: 1,
      uploadName: '上传',
      fixed: false,
      fixedNumber: [16, 9],
      option: {
        img: '',
        size: 0.7,
        full: false,
        // 使用 JPEG 输出以缩小体积
        outputType: 'jpeg',
        canMove: true,
        fixedBox: false,
        original: true,
        canMoveBox: true,
        autoCrop: false,
        // 只有自动截图开启 宽度高度才生效
        // autoCropWidth: 160,
        // autoCropHeight: 150,
        centerBox: false,
        high: false,
        max: 99999
      },
      picId: '',
      newPicId: '',
      crap: false,
      previews: {},
      visiblePic: false,
      loadingPic: false,
      loading: false,
      modals: true,
      allTreeList: [],
      categoryProps: {
        value: 'id',
        label: 'name',
        children: 'child',
        expandTrigger: 'hover',
        checkStrictly: true,
        emitPath: false
      },
      editPram: {
        pid: 0,
        name: '',
        type: 2,
        sort: 1,
        status: 0,
        url: 'url',
        id: 0
      },
      visible: false,
      bizTitle: '',
      sleOptions: {
        attrId: '',
        pid: ''
      },
      list: [],
      grid: {
        xl: 7,
        lg: 7,
        md: 7,
        sm: 7,
        xs: 24
      },
      grid2: {
        xl: 17,
        lg: 17,
        md: 17,
        sm: 17,
        xs: 24
      },
      filterText: '',
      //筛选分类
      filterName: '',
      //筛选图片/视频名称
      treeData: [],
      treeData2: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      tableData: {
        page: 1,
        limit: 20,
        pid: 0,
        attType: 'jpg,jpeg,gif,png,bmp,PNG,JPG'
      },
      listTableData: {
        page: 1,
        limit: 8,
        pid: 0,
        attType: 'jpg,jpeg,gif,png,bmp,PNG,JPG'
      },
      classifyId: 0,
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      },
      treeFrom: {
        status: -1,
        type: 2
      },
      pictrueList: {
        list: [],
        total: 0
      },
      isShowPic: false,
      checkPicList: [],
      ids: [],
      listPram: {
        pid: 0,
        type: 2,
        status: 0,
        name: '',
        page: 1,
        limit: 9999
      },
      localImg: '',
      originalFile: null,
      videoStatus: false,
      typeDate: 'pic',
      picDeleteConfig: {
        // 此处删除完全可以用confirm来替代，但是因为在多层dialog后再次 confirm 后就会出现index的层级问题，算是规避问题的处理方式
        dialogVisible: false,
        forDeleteId: 0
      }
    };
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  computed: {
    gridPicStyle: function gridPicStyle() {
      return {
        width: this.pictureType ? "".concat((this.divWidth - 104) / 6, "px") : '90px',
        marginLeft: this.pictureType ? '17px' : '20px',
        marginBottom: this.pictureType ? '42px' : '19px'
      };
    }
  },
  created: function created() {
    if (this.labelName) {
      this.option.fixedBox = true;
      this.option.autoCropWidth = 200;
      this.option.autoCropHeight = 100;
      var str = this.labelName;
      var regex = /\((.+?)\)/g; // 中括号
      var regexs = /（(.+?)）/g; // 中文小括号
    }
    this.pictureType ? this.tableData.limit = 18 : this.tableData.limit = 18;
    if (this.$route && this.$route.query.field === 'dialog') Promise.resolve().then(function () {
      return _interopRequireWildcard(require('../js/internal.js'));
    });
    if ((0, _permission.checkPermi)(['merchant:category:list:tree'])) this.getList();
    if ((0, _permission.checkPermi)(['merchant:attachment:list'])) this.getFileList();
  },
  mounted: function mounted() {
    if (this.pictureType) {
      // 在mounted钩子函数中获取div的初始宽度
      this.divWidth = this.$refs.myDiv.offsetWidth;
      window.addEventListener('resize', this.getWindowInfo);
    }
  },
  destroyed: function destroyed() {
    //移除监听事件
    window.removeEventListener('resize', this.getWindowInfo);
  },
  methods: {
    //视口大小变化更改盒子宽度
    getWindowInfo: function getWindowInfo() {
      this.divWidth = this.$refs.myDiv.offsetWidth;
    },
    allAdd: function allAdd(label) {
      if (label == '全部图片') {
        this.onAdd();
      }
    },
    //宫格删除操作
    deleteOperate: function deleteOperate(item) {
      var _this = this;
      this.$modalSure().then(function () {
        (0, _systemSetting.fileDeleteApi)(item.attId).then(function () {
          _this.$message.success('刪除成功');
          _this.tableData.page = 1;
          _this.getFileList();
          _this.uploadName = '上传';
        });
      });
    },
    //移入移出显示操作
    handleMouse: function handleMouse(item, type) {
      this.$set(item, 'isCk', type);
    },
    //查看模态框控制
    checkHandleClose: function checkHandleClose(done) {
      this.$confirm('确认关闭？').then(function (_) {
        done();
      }).catch(function (_) {});
    },
    //列表选中
    listSelectionChange: function listSelectionChange(val) {
      var _this2 = this;
      this.checkPicList = val;
      val.forEach(function (element) {
        _this2.ids.push(element.attId);
      });
    },
    deleteListFun: function deleteListFun(scope) {
      var _this3 = this;
      this.$modalSure().then(function () {
        (0, _systemSetting.fileDeleteApi)(scope.row.attId).then(function () {
          _this3.$message.success('刪除成功');
          _this3.tableData.page = 1;
          _this3.getFileList();
          _this3.checkPicList = [];
          _this3.uploadName = '上传';
        });
      });
    },
    //promise 获取列表，用于同步切换分类
    getFileListAsync: function getFileListAsync() {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        _this4.loadingPic = true;
        if (_this4.tableData.pid === 0) _this4.tableData.pid = null;
        (0, _systemSetting.fileListApi)(_this4.tableData).then(/*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  res.list.forEach(function (element) {
                    element.sattDir = element.sattDir;
                  });
                  _this4.pictrueList.list = res.list;
                  console.log(_this4.pictrueList.list);
                  if (_this4.tableData.page === 1 && _this4.pictrueList.list.length > 0) _this4.pictrueList.list[0].localImg = _this4.localImg;
                  if (_this4.pictrueList.list.length) {
                    _this4.isShowPic = false;
                  } else {
                    _this4.isShowPic = true;
                  }
                  _this4.pictrueList.total = res.total;
                  _this4.checkPicList = [];
                  _this4.loadingPic = false;
                  resolve();
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).catch(function () {
          _this4.loadingPic = false;
        });
      });
    },
    //切换宫格或列表
    checkoutBtn: function checkoutBtn(type) {
      var _this5 = this;
      if (type === 0) {
        // this.pictureType ? (this.tableData.limit = 10) : (this.tableData.limit = 7);
        this.tableData.limit = 10;
        this.tableData.page = 1;
        this.checkPicList = [];
        this.ids = [];
        //请求成功后切换列表
        this.getFileListAsync().then(function () {
          _this5.listType = type;
        });
      } else {
        this.tableData.limit = 18;
        this.tableData.page = 1;
        this.checkPicList = [];
        this.ids = [];
        this.getFileListAsync().then(function () {
          _this5.listType = type;
        });
      }
    },
    checkPermi: _permission.checkPermi,
    // 选取图片后自动回调，里面可以获取到文件
    imgSaveToUrl: function imgSaveToUrl(event) {
      // 也可以用file
      this.localFile = event.raw; // 或者 this.localFile=file.raw

      // 转换操作可以不放到这个函数里面，
      // 因为这个函数会被多次触发，上传时触发，上传成功也触发
      var reader = new FileReader();
      reader.readAsDataURL(this.localFile); // 这里也可以直接写参数event.raw

      // 转换成功后的操作，reader.result即为转换后的DataURL ，
      // 它不需要自己定义，你可以console.integralLog(reader.result)看一下
      reader.onload = function () {
        // console.integralLog(reader.result)
      };

      /* 另外一种本地预览方法 */
      var URL = window.URL || window.webkitURL;
      this.localImg = URL.createObjectURL(event.raw);
      // 转换后的地址为 blob:http://xxx/7bf54338-74bb-47b9-9a7f-7a7093c716b5
    },
    closeModel: function closeModel() {
      this.$refs['editPram'].resetFields();
    },
    handlerSubmit: function handlerSubmit(formName) {
      var _this6 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this6.editPram.pid > 0) {
            if (_this6.editPram.pid === _this6.editPram.id) return _this6.$message.warning('上级分类不能选当前分类');
          }
          _this6.bizTitle === '添加分类' ? (0, _categoryApi.addCategroy)(_this6.editPram).then(function (data) {
            _this6.$message.success('创建成功');
            _this6.visible = false;
            _this6.getList();
          }) : (0, _categoryApi.updateCategroy)(_this6.editPram).then(function (data) {
            _this6.$message.success('编辑成功');
            _this6.visible = false;
            _this6.getList();
          });
        } else {
          return false;
        }
      });
    },
    // 表单分类
    handlerGetList: function handlerGetList() {
      var _this7 = this;
      var datas = {
        name: '全部图片',
        id: ''
      };
      (0, _categoryApi.treeCategroy)(this.treeFrom).then(function (data) {
        _this7.allTreeList = data;
        _this7.allTreeLis.unshift(datas);
      });
    },
    // 搜索分类
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 所有分类
    getList: function getList() {
      var _this8 = this;
      var data = {
        name: '全部图片',
        id: 0
      };
      (0, _categoryApi.treeCategroy)(this.treeFrom).then(function (res) {
        _this8.treeData = res;
        _this8.treeData.unshift(data);
        _this8.treeData2 = _toConsumableArray(_this8.treeData);
      });
    },
    // 添加分类
    onAdd: function onAdd(id) {
      this.tableData.pid = id;
      this.bizTitle = '添加分类';
      this.visible = true;
      if (id) this.editPram = {
        pid: id,
        name: '',
        type: 2,
        sort: 1,
        status: 0,
        url: 'url',
        id: 0
      };
    },
    // 编辑
    onEdit: function onEdit(id) {
      var _this9 = this;
      this.bizTitle = '编辑分类';
      this.loading = true;
      (0, _categoryApi.infoCategroy)(id).then(function (res) {
        _this9.editPram = res;
        _this9.loading = false;
      });
      this.visible = true;
    },
    // 删除
    handleOpenDelete: function handleOpenDelete(id) {
      var _this0 = this;
      this.picDeleteConfig.forDeleteId = id;
      this.picDeleteConfig.dialogVisible = true;
      this.$modalSure('删除当前分类吗').then(function () {
        (0, _categoryApi.deleteCategroy)(_this0.picDeleteConfig.forDeleteId).then(function () {
          _this0.$message.success('删除成功');
          _this0.picDeleteConfig.forDeleteId = 0;
          _this0.getList();
        });
      });
    },
    handleNodeClick: function handleNodeClick(data) {
      this.checkPicList = [];
      this.pictrueList.list = [];
      this.tableData.pid = data.id;
      this.tableData.page = 1;
      this.getFileList();
    },
    // 上传
    handleUploadForm: function handleUploadForm(param) {
      var formData = new FormData();
      var data = {
        model: 'product',
        pid: this.tableData.pid ? this.tableData.pid : 0
      };
      formData.append('multipart', param.file);
      this.uploadPic(formData, data);
    },
    uploadPic: function uploadPic(formData, data) {
      var _this1 = this;
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _systemSetting.fileImageApi)(formData, data).then(function (res) {
        loading.close();
        _this1.$message.success('上传成功');
        _this1.tableData.page = 1;
        _this1.getFileList();
        _this1.onCallback();
      }).catch(function (res) {
        _this1.onCallback();
        loading.close();
      });
    },
    // 文件列表
    getFileList: function getFileList() {
      var _this10 = this;
      this.loadingPic = true;
      if (this.tableData.pid === 0) this.tableData.pid = null;
      (0, _systemSetting.fileListApi)(this.tableData).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                res.list.forEach(function (element) {
                  element.sattDir = element.sattDir;
                });
                _this10.pictrueList.list = res.list;
                console.log(_this10.pictrueList);
                if (_this10.tableData.page === 1 && _this10.pictrueList.list.length > 0) _this10.pictrueList.list[0].localImg = _this10.localImg;
                if (_this10.pictrueList.list.length) {
                  _this10.isShowPic = false;
                } else {
                  _this10.isShowPic = true;
                }
                _this10.pictrueList.total = res.total;
                _this10.checkPicList = [];
                _this10.loadingPic = false;
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function () {
        _this10.loadingPic = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableData.page = page;
      this.checkPicList = [];
      this.getFileList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableData.limit = val;
      this.getFileList();
    },
    // 选中图片
    changImage: function changImage(item, index, row) {
      var _this11 = this;
      var activeIndex = 0;
      if (!item.isSelect) {
        this.$set(item, 'isSelect', true);
        this.checkPicList.push(item);
      } else {
        this.$set(item, 'isSelect', !item.isSelect);
        this.checkPicList.map(function (el, index) {
          if (el.attId == item.attId) {
            activeIndex = index;
          }
        });
        this.checkPicList.splice(activeIndex, 1);
      }
      this.ids = [];
      this.checkPicList.map(function (item, i) {
        _this11.ids.push(item.attId);
      });
      if (this.checkPicList.length > 0) {
        this.uploadName = '裁剪图片';
      } else {
        this.uploadName = '上传';
      }
      this.pictrueList.list.map(function (el, i) {
        if (el.isSelect) {
          _this11.checkPicList.filter(function (el2, j) {
            if (el.attId == el2.attId) {
              el.num = j + 1;
              _this11.$nextTick(function () {
                _this11.pictrueList.list;
              });
            }
          });
        } else {
          el.num = 0;
        }
      });
    },
    // 点击使用选中图片
    checkPics: function checkPics() {
      if (!this.checkPicList.length) return this.$message.warning('请先选择图片');
      if (this.$route && this.$route.query.field === 'dialog') {
        var str = '';
        for (var i = 0; i < this.checkPicList.length; i++) {
          str += '<img src="' + this.checkPicList[i].sattDir + '">';
        }
        /* eslint-disable */
        nowEditor.dialog.close(true);
        nowEditor.editor.setContent(str, true);
      } else {
        if (this.isMore === '1' && this.checkPicList.length > 1) {
          return this.$message.warning('最多只能选一张图片');
        }
        this.$emit('getImage', [].concat(_toConsumableArray(this.checkedMore), _toConsumableArray(this.checkPicList)));
      }
    },
    // 删除图片
    editPicList: function editPicList(tit) {
      var _this12 = this;
      if (!this.checkPicList.length) return this.$message.warning('请先选择图片');
      this.$modalSure().then(function () {
        (0, _systemSetting.fileDeleteApi)(_this12.ids.join(',')).then(function () {
          _this12.$message.success('刪除成功');
          _this12.tableData.page = 1;
          _this12.getFileList();
          _this12.checkPicList = [];
          _this12.uploadName = '上传';
        });
      });
    },
    // 移动分类点击
    handleSelClick: function handleSelClick(node) {
      if (this.ids.length) {
        this.sleOptions = {
          attrId: this.ids.join(','),
          pid: node.id
        };
        this.getMove();
      } else {
        this.$message.warning('请先选择图片');
      }
    },
    getMove: function getMove() {
      var _this13 = this;
      (0, _systemSetting.attachmentMoveApi)(this.sleOptions).then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _this13.$message.success('操作成功');
                _this13.clearBoth();
                _this13.tableData.page = 1;
                _this13.getFileList();
              case 1:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this13.clearBoth();
      });
    },
    clearBoth: function clearBoth() {
      this.sleOptions = {
        attrId: '',
        pid: ''
      };
      this.checkPicList = [];
      this.ids = [];
    },
    videoChange: function videoChange(val) {
      if (val == false) {
        this.$set(this.tableData, 'attType', 'jpg,jpeg,gif,png,bmp,PNG,JPG');
        this.tableData.page = 1;
        this.getFileList();
      } else {
        this.$set(this.tableData, 'attType', 'video/mp4');
        this.tableData.page = 1;
        this.getFileList();
      }
    },
    radioChange: function radioChange(event) {
      if (event.name === 'video') {
        this.videoChange(true);
      } else {
        this.videoChange(false);
      }
    },
    /**
     * 裁剪图片
     * @returns {ElMessageComponent}
     */
    startCrop: function startCrop() {
      this.crap = true;
      this.$refs.cropper.startCrop();
    },
    stopCrop: function stopCrop() {
      //  stop
      this.crap = false;
      this.$refs.cropper.stopCrop();
    },
    clearCrop: function clearCrop() {
      // clear
      this.$refs.cropper.clearCrop();
    },
    handleChangeImage: function handleChangeImage() {
      if (this.checkPicList.length > 1) {
        return this.$message.warning('最多只能选一张图片');
      }
      this.visiblePic = true;
      if (this.checkPicList.length > 0) this.imageToBase64(this.checkPicList[0].sattDir);
    },
    saveNewPic: function saveNewPic() {
      var _this14 = this;
      // if (!this.newPicId) {
      //   return this.$message.warning("请上传裁剪后的图片");
      // }
      this.$refs.cropper.getCropBlob(function (data) {
        _this14.downImg = window.URL.createObjectURL(data);
        // aLink.download = this.downImg;
        _this14.$emit('getImage', [{
          sattDir: _this14.downImg
        }]);
      });
    },
    onCallback: function onCallback() {
      this.visiblePic = false;
      this.option.img = '';
      this.stopCrop();
      this.clearCrop();
    },
    changeScale: function changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    rotateLeft: function rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight: function rotateRight() {
      this.$refs.cropper.rotateRight();
    },
    // 实时预览函数
    realTime: function realTime(data) {
      this.previews = data;
    },
    //image转Base64
    imageToBase64: function imageToBase64(file) {
      var _this15 = this;
      //一定要设置为let，不然图片不显示
      var image = new Image();
      //解决跨域问题
      image.setAttribute('crossOrigin', 'anonymous');
      var imageUrl = file;
      image.src = imageUrl;
      //image.onload为异步加载
      image.onload = function () {
        var maxW = 1600;
        var maxH = 1600;
        var w = image.width;
        var h = image.height;
        if (w > maxW || h > maxH) {
          var ratio = Math.min(maxW / w, maxH / h);
          w = Math.floor(w * ratio);
          h = Math.floor(h * ratio);
        }
        var canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, w, h);
        var quality = 0.75;
        // 仅用于传入裁剪器显示，使用 JPEG 以控制体积
        var dataURL = canvas.toDataURL('image/jpeg', quality);
        _this15.option.img = dataURL;
      };
    },
    // 将base64转换为文件 百度随便找的 看需求使用
    dataURLtoFile: function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime
      });
    },
    uploadNewPic: (0, _validate.Debounce)(function () {
      var _this16 = this;
      // 直接导出二进制 Blob，避免 base64 体积膨胀；按 JPEG 上传
      this.$refs.cropper.getCropBlob(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(blob) {
          var name, compressed, file, datas, formData;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                name = Date.now();
                _context4.n = 1;
                return _this16.compressToJpeg(blob, 1280, 1280, 0.75);
              case 1:
                compressed = _context4.v;
                file = new File([compressed], "".concat(name, ".jpg"), {
                  type: 'image/jpeg'
                });
                datas = {
                  model: _this16.modelName ? _this16.modelName : 'product',
                  pid: _this16.tableData.pid ? _this16.tableData.pid : 0
                };
                formData = new FormData();
                formData.append('multipart', file);
                _this16.uploadPic(formData, datas);
              case 2:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }());
    }),
    // 原图直传（不压缩，不改格式）
    uploadOriginalPic: function uploadOriginalPic() {
      if (!this.originalFile) {
        this.$message.warning('请先在下方选择本地图片');
        return;
      }
      var datas = {
        model: this.modelName ? this.modelName : 'product',
        pid: this.tableData.pid ? this.tableData.pid : 0
      };
      var formData = new FormData();
      formData.append('multipart', this.originalFile);
      this.uploadPic(formData, datas);
    },
    // 将裁剪得到的 blob 以指定最大尺寸与质量重新编码为 JPEG（默认最大 1280x1280，质量 0.75）
    compressToJpeg: function compressToJpeg(blob) {
      var maxWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1280;
      var maxHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1280;
      var quality = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.75;
      return new Promise(function (resolve) {
        try {
          var img = new Image();
          img.onload = function () {
            var width = img.width,
              height = img.height;
            if (width > maxWidth || height > maxHeight) {
              var ratio = Math.min(maxWidth / width, maxHeight / height);
              width = Math.floor(width * ratio);
              height = Math.floor(height * ratio);
            }
            var canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            canvas.toBlob(function (out) {
              if (out && out.size > 0 && out.size < blob.size) resolve(out);else resolve(blob);
            }, 'image/jpeg', quality);
          };
          img.onerror = function () {
            return resolve(blob);
          };
          img.src = URL.createObjectURL(blob);
        } catch (e) {
          resolve(blob);
        }
      });
    },
    down: function down(type) {
      var _this17 = this;
      // event.preventDefault()
      var aLink = document.createElement('a');
      aLink.download = 'author-img';
      // 输出
      if (type === 'blob') {
        this.$refs.cropper.getCropBlob(function (data) {
          _this17.downImg = window.URL.createObjectURL(data);
          // aLink.download = this.downImg;
          aLink.href = window.URL.createObjectURL(data);
          aLink.click();
        });
      } else {
        this.$refs.cropper.getCropData(function (data) {
          _this17.downImg = data;
          aLink.href = data;
          aLink.click();
        });
      }
    },
    uploadImg: function uploadImg(e) {
      var _this18 = this;
      //上传图片
      var file = e.target.files[0];
      this.originalFile = file;
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        this.$message.warning('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种');
        return false;
      }
      var reader = new FileReader();
      reader.onload = function (e) {
        var data;
        if (_typeof(e.target.result) === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        _this18.option.img = data;
      };
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file);
    },
    imgLoad: function imgLoad(msg) {}
  }
};